// Public + authenticated client portal service (token-based)
import { http } from "./http";

export const portalService = {
  load: (token) => http.get(`/api/portal/${token}`).then((r) => r.data),
  saveProgress: (token, step_id, answers, completed = false) =>
    http.post(`/api/portal/${token}/progress`, { step_id, answers, completed }).then((r) => r.data),
  sign: (token, payload) =>
    http.post(`/api/portal/${token}/sign`, payload).then((r) => r.data),
};
